import store from '@/store'
import D2C_Entity from './Entity'

class D2C_Region extends D2C_Entity {
  target = 'region'
  icon = 'flag'
  static create(props) {
    return new D2C_Region(props)
  }
  get _fullTitle() {
    return this.city
  }
  get _hosts() {
    return store.getters.hosts.filter(host => host.region === this.id)
  }
}

export default D2C_Region
